import type { ReactNode } from "react";

interface MarqueeProps {
  children: ReactNode;
  className?: string;
  innerClassName?: string;
  direction?: "left";
}

export function Marquee({ children, className = "", innerClassName = "" }: MarqueeProps) {
  return (
    <div className={`marquee ${className}`}>
      {[0, 1].map((copy) => (
        <div
          key={copy}
          aria-hidden={copy === 1 ? true : undefined}
          className={`marquee-track ${innerClassName}`}
        >
          {children}
        </div>
      ))}
    </div>
  );
}
